<mat-card class="paypoints-card">
  <div class="card-header">
    <h2 class="card-title">Paypoints</h2>
    <button mat-raised-button color="primary" class="add-button" (click)="onAddPaypoint()">
      <mat-icon>add</mat-icon>
      Add Paypoint
    </button>
  </div>

  <div class="paypoints-list">
    <kt-bridgepay-paypoint-item
      *ngFor="let paypoint of paypoints"
      [paypoint]="paypoint"
      (edit)="onEdit($event)"
      (delete)="onDelete($event)"
      (test)="onTest($event)"
    >
    </kt-bridgepay-paypoint-item>
  </div>
</mat-card>
